<template>
  <div :class="_class">
    <div class="timeline-element">
      <slot>
        <template
          v-if="
            (dateTime && dateTime.date && dateTime.time) ||
            typeof dateTime === 'string'
          "
        >
          <span v-if="typeof dateTime === 'string'" class="timeline-date">{{
            dateTime
          }}</span>
          <span v-else class="timeline-date">{{ dateTime.date }}</span>
          <span
            v-if="showTime && dateTime.time"
            class="timeline-time block-block text-uppercase text-light text-size-small text-align-right"
            >{{ dateTime.time }}</span
          >
        </template>
      </slot>
    </div>
    <span
      :class="'timeline-symbol plt prt ' + eventScope"
      role="img"
      :aria-label="timelineImgText"
      :aria-hidden="timelineImgText.includes('Timeline') ? true : null"
      ><span class="arrow"></span
    ></span>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop } from "vue-facing-decorator";

@Component({ name: "cat-timeline-item" })
export default class CatTimelineItem extends Vue {
  @Prop({ type: String }) readonly eventScope?: string;
  @Prop({ type: String, default: "Timeline" }) readonly eventScopeText?: string;
  @Prop({ type: Boolean, default: true }) readonly down?: boolean;
  @Prop({ type: Boolean, default: true }) readonly showTime?: boolean;
  @Prop([Object, String]) readonly dateTime?: object | string;

  get _class(): object {
    return {
      "cat-timeline-item": true,
      [this.eventScope as string]: true
    };
  }

  get timelineImgText(): string {
    return this.eventScopeText as string;
  }
}
</script>
